import React from 'react';

import PropTypes from 'prop-types';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import ContextSwitcher from 'components/userBar/components/ContextSwitcher';
import UserMenu from 'components/userBar/components/UserMenu';

import { resourceShape } from 'components/helpers/serialisableResources';
import { personDisplayName } from 'components/helpers/users';

export default function UserBar({
  isContextSwitcherVisible,
  isDashboardAccessible,
  isImpersonatorInfoVisible,
  isProcoreSession,
  isTrainingProfileNavigationVisible,
  lineManager,
  personnelId,
  personnelProfilePhoto,
}) {
  const { user: currentUser } = useCurrentActor();

  return (
    <div className='tw-flex tw-h-10 tw-items-center tw-bg-grey-700'>
      {isContextSwitcherVisible && (
        <div className='tw-flex-none'>
          <ContextSwitcher isDashboardAccessible={isDashboardAccessible} />
        </div>
      )}
      <div className='tw-flex tw-flex-auto tw-items-center tw-justify-end'>
        {isImpersonatorInfoVisible && (
          <div className='tw-flex tw-h-5 tw-flex-auto tw-items-center tw-justify-end tw-text-grey-100'>
            You are currently acting on behalf of{' '}
            {personDisplayName({ attributes: currentUser.attributes })}
          </div>
        )}
        <div className='tw-ml-3 tw-h-8 tw-flex-none'>
          <UserMenu
            isProcoreSession={isProcoreSession}
            isTrainingProfileNavigationVisible={
              isTrainingProfileNavigationVisible
            }
            lineManager={lineManager}
            personnelId={personnelId}
            personnelProfilePhoto={personnelProfilePhoto}
          />
        </div>
      </div>
    </div>
  );
}

UserBar.propTypes = {
  isDashboardAccessible: PropTypes.bool.isRequired,
  isContextSwitcherVisible: PropTypes.bool.isRequired,
  isImpersonatorInfoVisible: PropTypes.bool.isRequired,
  isProcoreSession: PropTypes.bool.isRequired,
  isTrainingProfileNavigationVisible: PropTypes.bool.isRequired,
  personnelId: PropTypes.string,
  personnelProfilePhoto: resourceShape('profilePhoto'),
  lineManager: resourceShape('personnel'),
};
